import { Parameter } from '@src/main/modules/parameters/domain/parameters-management/parameter.interface';

export interface UpdateParameterRequest {
  parameterId: string;
  parameter: string;
  description: string;
  value: string | boolean;
}

export const toUpdateParameterRequest = (parameter: Parameter): UpdateParameterRequest => ({
  parameterId: parameter.parameterId,
  parameter: parameter.parameter,
  description: parameter.description,
  value: parameter.value,
});
